import React, { Component } from 'react';
import { StackedBarChart , LegendComp } from '../../../common/graph/bar-graph.component';
import { ChartHeaderDropdown } from '../../../common/data-header/chart-header-dropdown.component';
import '../report-page.component.css';

const graphData = [
    { name: 'Language Skills of our personnel', verysatisfied: 1, dissatisfied: 2, neutral: 3, satisfied: 10, verysatisfied: 80 },
    { name: 'The ability of the support personnel to understand', verysatisfied: 2, dissatisfied: 2, neutral: 5, satisfied: 29, verysatisfied: 55 },
    { name: 'The completeness of the solution provided', verysatisfied: 1, dissatisfied: 3, neutral: 4, satisfied: 12, verysatisfied: 69 },
    { name: 'The promptness of the solution provided', verysatisfied: 3, dissatisfied: 2, neutral: 12, satisfied: 15, verysatisfied: 64 }
  ];

const  barData = [ {dataKey: 'verysatisfied', name: 'Very Dissatisfied', color:'#d5002f'}, 
    { dataKey: 'dissatisfied', name: 'Dissatisfied', color:'#ffc82c'}, 
    { dataKey: 'neutral', name: 'Neutral', color:'#919eab'}, 
    { dataKey: 'satisfied', name: 'Satisfied', color:'#008eff'}, 
    { dataKey: 'verysatisfied', name: 'Very satisfied', color:'#7ec344'}
]


class DistributionComp extends Component {
    render() {
        return (
            <div className="component-container legend-center">              
                <ChartHeaderDropdown haveOneIcone={true} haveIconInfo={true} iconInfo="info-circle-solid" haveLedger={false} headerName="Satisfaction Distribution" circleIcon={false} circleFirstIcon="list-regular" circleSecondIcon="th-solid" oneIcon="vertical-grid" 
                          haveInput={false} haveDropdown={false}   />  
                <StackedBarChart data={graphData} barData={barData} displayLegend={true} legendData={barData} tickFormat={tick => `${tick}%`} domainFormat={[0, 100]}/>  
                <LegendComp data={barData} />                  
            </div>
        )
    }
}

export default DistributionComp;